import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Common, color, Widget } from '@stockbit/ui';

import allWatchlistSlice from '../slice';

import slice, { effects, selectors } from './slice';
import CreateModal from './CreateModal';
import DeleteModal from './DeleteModal';
import WatchlistItem from './WatchlistItem';

const { Text } = Common;
const { Button } = Widget;

const { actions } = slice;
const { actions: allWatchlistActions } = allWatchlistSlice;

type propTypes = {
  watchlistId: string;
};

function ListWatchlist({ watchlistId }: propTypes) {
  const dispatch = useDispatch();
  const { saved } = useSelector(selectors);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  const handleRowHover = (hoveredRowIndex: number | null) => {
    setHoveredRow(hoveredRowIndex);
  };

  const handleWatchlistClick = (id: string) => {
    dispatch(
      allWatchlistActions.setCurrentwatchlistId({
        watchlistId: id,
      }),
    );
    dispatch(allWatchlistActions.toggleViewType({ listType: 'company' }));
  };

  useEffect(() => {
    dispatch(effects.getSavedWatchlist());
  }, [dispatch]);

  const handleCreateNewClick = () => dispatch(actions.toggleCreateModal({}));

  return (
    <div
      style={{
        height: 'calc(100% - 40px)',
        overflowY: 'auto',
        padding: '19px 12px 0',
        backgroundColor: color.light,
      }}
    >
      <Button
        block
        round
        height="35px"
        margin="0 0 12px"
        type="defaultHoverable"
        onClick={handleCreateNewClick}
      >
        <Text color="inherit" align="center">
          Create New Watchlist
        </Text>
      </Button>
      {saved.map(({ name, watchlist_id: id, is_default: isDefault }, index) => (
        <WatchlistItem
          id={id}
          index={index}
          name={isDefault ? 'All Watchlist' : name}
          hoveredRow={hoveredRow}
          onHover={handleRowHover}
          onClick={handleWatchlistClick}
          key={`watchlist-${id}`}
        />
      ))}
      <CreateModal />
      <DeleteModal />
    </div>
  );
}

export default ListWatchlist;
